import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M18.9 15.1a3 3 0 01.1.9 3 3 0 11-3-3 3 3 0 01.9.1 1.5 1.5 0 00-.9 1.4 1.5 1.5 0 001.5 1.5 1.5 1.5 0 001.4-.9z"/><path d="M29.5 14.7c-12.5-15-23.4-4.3-27 0a2 2 0 000 2.6c12.5 15 23.4 4.3 27 0a2 2 0 000-2.6zM16 22a6 6 0 116-6 6 6 0 01-6 6z"/>';
export var EyeOpenSVG = function EyeOpenSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
EyeOpenSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(EyeOpenSVG);